import { useGridUserDataGlobalFiltersContext } from "contexts/GridUserDataGlobalFiltersProvider";
import { AppList } from "components/list/AppList";
import React from "react";
import { Datagrid, FunctionField, ReferenceField, TextField } from "react-admin";
import { EditButton } from "react-admin";

import { DateFormatField } from "../../../components/fields/DateFormatField";
import { SelectEnumField } from "../../../components/fields/SelectEnumField";
import { ScrollingWrapper } from "../../../components/ScrollingWrapper";
import { TerminalSettingPerDateType } from "../../../entities/TerminalSettingPerDateType";
import { TerminalSettingPerDateFilters } from "./ListFilters";

const defaultSort = { field: "id", order: "DESC" };

export const TerminalSettingPerDateList = (props) => {
	const { data: globalFilters = {}, isLoading } = useGridUserDataGlobalFiltersContext();

	if (isLoading) return null;

	const currentFilters = { terminal_id: globalFilters?.terminal_id };

	return (
		<AppList
			{...props}
			sort={defaultSort}
			exporter={false}
			bulkActionButtons={false}
			filters={<TerminalSettingPerDateFilters />}
			filterDefaultValues={currentFilters}
			filter={currentFilters}
		>
			<ScrollingWrapper>
				<Datagrid>
					<TextField source="id" />
					<SelectEnumField
						source="type"
						enumName="terminal_setting_per_date_type"
						enumObj={TerminalSettingPerDateType}
						sortable={false}
					/>
					<ReferenceField source="terminal_id" reference="terminal" link={false}>
						<TextField source="name" />
					</ReferenceField>

					<DateFormatField source="date_from" />
					<DateFormatField source="date_to" />
					<FunctionField
						source="value"
						render={(record) =>
							record.value != null ? (record.value * 100).toFixed(5).replace(/\.?0+$/, "") : ""
						}
					/>
					<EditButton label="" />
				</Datagrid>
			</ScrollingWrapper>
		</AppList>
	);
};
